import React from "react"

import * as styles from "./MediaCard.module.scss"
import Brochure from "../../../../static/images/media_thumbnails/Brochure.svg"
import Documentation from "../../../../static/images/media_thumbnails/Documentation.svg"
import Infographic from "../../../../static/images/media_thumbnails/Infographic.svg"
import News from "../../../../static/images/media_thumbnails/News.svg"
import Vlog from "../../../../static/images/media_thumbnails/Vlog.svg"
import Webinar from "../../../../static/images/media_thumbnails/Webinar.svg"

const GetImageFromMediaType = (type) => {
  switch(type) {
    case "media_brochure":
      return <img src={Brochure} alt="Brochure Icon" width="86" height="116"/>
      // return <img src="/images/media_thumbnails/media_card_brochure.jpg" alt="Brochure Icon" />
    case "media_press_release":
      return <img src={News} alt="Press Release Icon" width="86" height="116"/>
      // return <img src="/images/media_thumbnails/media_card_press_release.jpg" alt="Press Release Icon" />
    case "media_video":
      return <img src={Webinar} alt="Video Icon" width="128" height="86"/>
      // return <img src="/images/media_thumbnails/media_card_video.jpg" alt="Video Icon" />
    case "media_webinar":
      return <img src={Vlog} alt="Webinar Icon" width="128" height="86"/>
    case "media_documentation":
      return <img src={Documentation} alt="Documentation Icon" width="86" height="116"/>
      // return <img src="/images/media_thumbnails/media_card_documentation.jpg" alt="Documentation Icon" />
    case "media_infographic":
      return <img src={Infographic} alt="Documentation Icon" width="86" height="116" />
      // return <img src="/images/media_thumbnails/media_card_infographic.jpg" alt="Documentation Icon" />
    default:
      return <div></div>
  }
}

const MediaCard = ({ type, label, title, excerpt, cta_text, cta_link, file, target }) => (
  <div className={`panel-radius shadow-cards ${styles.wrapper}`}>
    <div className={styles.image}>
      {GetImageFromMediaType(type || "")}
      {type === "media_brochure" || type === "media_documentation" || type === "media_infographic" ? (
        <span className={styles.link_overlay}>{file ? (<a href={file} target="_blank"></a>) : null}</span>
      ) : (
        <span className={styles.link_overlay}>{cta_link ? (<a href={cta_link} target={target}></a>) : null}</span>
      )}
    </div>
    <div className={styles.content}>
      {label ? <div className={styles.label}>{label}</div> : null}
      {/* {title ? <div className={styles.title}>{title}</div> : null} */}
      {type === "media_brochure" || type === "media_documentation" || type === "media_infographic" ? (
        <div className={styles.title}>{title && file ? (<a href={file} target="_blank">{title}</a>) : null}</div>
      ) : (
        <div className={styles.title}>{title && cta_link ? (<a href={cta_link} target={target}>{title}</a>) : null}</div>
      )}
      {excerpt ? <p>{excerpt}</p> : null}
      {type === "media_brochure" || type === "media_documentation" || type === "media_infographic" ? (
        <span className={styles.cta}>{cta_text && file ? (<a href={file} target="_blank">{cta_text}</a>) : null}</span>
      ) : (
        <span className={styles.cta}>{cta_text && cta_link ? (<a href={cta_link} target={target}>{cta_text}</a>) : null}</span>
      )}
    </div>
  </div>
)

export default MediaCard